export default __webpack_public_path__ + "static/blackLogo-181afd5825fd5022b2207766648dcb3a.png";